/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconPreview(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M4.284 5.21A4.055 4.055 0 0 0 4 6.706c0 2.222 1.782 4.04 4 4.04s4-1.818 4-4.04c0-.529-.1-1.034-.284-1.498.291.189.57.402.84.639.436.38 1.143 1.143 1.739 2.175-.596 1.031-1.303 1.793-1.738 2.175-1.244 1.09-2.692 1.68-4.557 1.68-1.865 0-3.313-.59-4.557-1.68-.435-.382-1.142-1.144-1.738-2.175.596-1.032 1.303-1.794 1.738-2.175.27-.237.55-.45.841-.639zM8 2.666c-2.233 0-4.03.725-5.546 2.053-.603.53-1.544 1.564-2.27 2.957l-.18.347.18.346c.726 1.393 1.667 2.428 2.27 2.957C3.97 12.653 5.767 13.378 8 13.378s4.03-.725 5.546-2.052c.603-.53 1.544-1.564 2.27-2.957l.18-.346-.18-.347c-.726-1.393-1.667-2.427-2.27-2.956C12.03 3.392 10.233 2.667 8 2.667zm0 1.5c1.372 0 2.5 1.128 2.5 2.54 0 1.411-1.128 2.54-2.5 2.54s-2.5-1.129-2.5-2.54c0-1.412 1.128-2.54 2.5-2.54z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M6.703 7.382A6.073 6.073 0 0 0 6.113 10c0 3.292 2.614 6 5.887 6 3.273 0 5.886-2.708 5.886-6 0-.936-.211-1.825-.589-2.618.573.341 1.115.744 1.634 1.204.674.596 1.77 1.793 2.683 3.414-.913 1.62-2.01 2.818-2.683 3.414C17.037 17.093 14.833 18 12 18s-5.037-.907-6.931-2.586c-.674-.596-1.77-1.793-2.683-3.414.913-1.62 2.01-2.818 2.683-3.414.519-.46 1.061-.863 1.634-1.204zM12 4C8.671 4 5.996 5.091 3.742 7.089c-.896.794-2.3 2.353-3.381 4.453L.125 12l.236.458c1.082 2.1 2.485 3.659 3.381 4.453C5.996 18.908 8.672 20 12 20c3.329 0 6.004-1.091 8.258-3.089.896-.794 2.3-2.353 3.38-4.453l.237-.458-.236-.458c-1.082-2.1-2.485-3.659-3.381-4.453C18.004 5.09 15.328 4 12 4zm0 2c2.125 0 3.886 1.77 3.886 4S14.125 14 12 14s-3.886-1.77-3.886-4S9.875 6 12 6z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconPreview is deprecated and will be archived soon. Use IconPreview instead.
 */
export function Experimental__IconPreview(props) {
  return /*#__PURE__*/React.createElement(IconPreview, props);
}